/**
 * Created by razial on 21.05.2026.
 */

if (cleverapps.styles.SingleProductOfferWindow && cleverapps.styles.SingleProductOfferWindow[Offers.TYPES.KINGSCUP]) {
    cleverapps.overrideStyles(cleverapps.styles.SingleProductOfferWindow[Offers.TYPES.KINGSCUP], {
        offer: {
            y: { align: "center", dy: -130 }
        },
        rewards: {
            energy: {
                rotation: 0,
                x: { align: "center", dx: -477 },
                y: { align: "center", dy: -112 }
            },
            worker: {
                rotation: 0,
                x: { align: "center", dx: 477 },
                y: { align: "center", dy: -112 }
            }
        },
        button: {
            y: { align: "bottom", dy: 50 }
        }
    });
}
